import React from "react";
import { useNavigate } from "react-router-dom";
import KernteamLayout from '../KernteamLayout';
import BackArrow from '../BackArrow';

function Logistik() {
  const navigate = useNavigate();

  return (
    <KernteamLayout>
      <div className="container">
        <BackArrow to="/kernteamportal" />
        <h1 className="section-title teal">Logistik</h1>
        <div className="button-container">
          <button className="button_boring_red teal" onClick={() => navigate("/logistik/schichtplan")}>
            <span className="material-symbols-outlined">schedule</span>
            Schichtplan
          </button>
          <button className="button_boring_red teal" onClick={() => navigate("/logistik/fahrten")}>
            <span className="material-symbols-outlined">directions_bus</span>
            Fahrten
          </button>
          <button className="button_boring_red teal" onClick={() => navigate("/logistik/inventar")}>
            <span className="material-symbols-outlined">inventory_2</span>
            Inventar
          </button>
        </div>
      </div>
    </KernteamLayout>
  );
}

export default Logistik;
